export class InventorySnapshotVolume {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "allocatedSize",
            "baseName": "allocatedSize",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "VolumeSettings",
            "format": ""
        },
        {
            "name": "volumeLabel",
            "baseName": "volumeLabel",
            "type": "string",
            "format": ""
        },
        {
            "name": "deviceName",
            "baseName": "deviceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InventorySnapshotVolume.attributeTypeMap;
    }
    constructor() {
    }
}
